/** React error codes raised when hydration is interrupted or mismatched and
 *  React recovers by discarding the server HTML and client-rendering:
 *  418/423/425 (mismatch variants), 421/422 (hydration interrupted/aborted).
 *  https://react.dev/errors/418 etc. */
const HYDRATION_ERROR_CODES = ["418", "421", "422", "423", "425"];

/** True when a recoverable error reported by React's `onRecoverableError` is a
 *  hydration recovery. Matches both production builds ("Minified React error
 *  #418…") and dev builds ("Hydration failed because…" / "There was an error
 *  while hydrating…"). */
export function isRecoverableHydrationError(error: unknown): boolean {
  const message = error instanceof Error ? error.message : typeof error === "string" ? error : "";
  if (!message) return false;
  if (HYDRATION_ERROR_CODES.some((code) => message.includes(`Minified React error #${code}`))) {
    return true;
  }
  return /hydrat/i.test(message);
}
